import FileExplorer from "../../../components/file-explorer/file-explorer";
import Page from "../../page";

const FileExplorerPage = () => {
  return (
    <Page>
      <FileExplorer />
    </Page>
  );
};

export default FileExplorerPage;
